import createSvgIcon from "./utils/create_icon"

const ChevronDown = createSvgIcon(<path clipRule="evenodd" d="M8.293 10.293a1 1 0 0 1 1.414 0L12 12.586l2.293-2.293a1 1 0 1 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 0 1 0-1.414z" fill="currentColor" fillRule="evenodd" />, "ChevronDown")
export default ChevronDown
